import { render, staticRenderFns } from "./subOperateSkillOrCommonSummary.vue?vue&type=template&id=0b081640&scoped=true"
import script from "./subOperateSkillOrCommonSummary.vue?vue&type=script&lang=js"
export * from "./subOperateSkillOrCommonSummary.vue?vue&type=script&lang=js"
import style0 from "./subOperateSkillOrCommonSummary.vue?vue&type=style&index=0&id=0b081640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b081640",
  null
  
)

export default component.exports